import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconPackagePlus: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M17.0833 6.06478L9.99997 9.99996M9.99997 9.99996L2.91664 6.06478M9.99997 9.99996L10 17.9167M11.6667 17.4074L10.6475 17.9736C10.4112 18.1049 10.293 18.1705 10.1679 18.1963C10.0571 18.2191 9.94288 18.2191 9.83213 18.1963C9.70698 18.1705 9.58881 18.1049 9.35248 17.9736L3.18581 14.5477C2.93621 14.409 2.8114 14.3397 2.72053 14.241C2.64013 14.1538 2.57929 14.0504 2.54207 13.9378C2.5 13.8104 2.5 13.6677 2.5 13.3821V6.61786C2.5 6.33233 2.5 6.18956 2.54207 6.06223C2.57929 5.94958 2.64013 5.84618 2.72053 5.75894C2.8114 5.66032 2.93621 5.59099 3.18581 5.45232L9.35248 2.02639C9.58881 1.8951 9.70698 1.82944 9.83213 1.80371C9.94288 1.78093 10.0571 1.78093 10.1679 1.80371C10.293 1.82944 10.4112 1.89509 10.6475 2.02639L16.8142 5.45232C17.0638 5.59099 17.1886 5.66032 17.2795 5.75893C17.3599 5.84618 17.4207 5.94958 17.4579 6.06222C17.5 6.18956 17.5 6.33232 17.5 6.61786L17.5 10.4167M6.25 3.74999L13.75 7.91665M15.8333 17.5V12.5M13.3333 15H18.3333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconPackagePlus.defaultProps = defaultIconProps;
